module.exports = __webpack_public_path__ + "img/userLogo17.e1dfb1c3.jpg";